import React, { FC, Fragment } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Link } from '@components/Link'
import {
  GroupLinkWrapper,
  GroupTitle,
  LinkText,
  LinkDescription,
  linkStyles,
} from './GroupLink.elements'

type LinkType = {
  text: string
  description: string
  url: string
}

type Props = {
  title: string
  links: LinkType[]
  onItemSelect?: () => void
}

export const GroupLink: FC<Props> = (props) => {
  const { title, links, onItemSelect } = props

  return (
    <GroupLinkWrapper>
      <GroupTitle>
        {title}
      </GroupTitle>

      {links.map((link, idx) => (
        <div key={idx}>
          <Link
            onClick={onItemSelect}
            href={link.url}
            css={linkStyles}
          >
            <LinkText>
              {link.text}
            </LinkText>
            <LinkDescription dangerouslySetInnerHTML={{ __html: link.description }} />
          </Link>
        </div>
      ))}
    </GroupLinkWrapper>
  )
}
